import { themeGlyph, useTheme } from "@/lib/theme";

export function ThemeButton({ id }: { id?: string }) {
  const [theme, toggle] = useTheme();
  return (
    <button
      type="button"
      className="thm"
      id={id}
      onClick={toggle}
      aria-label="Switch between light and dark"
      data-testid="theme-toggle"
    >
      {themeGlyph(theme)}
    </button>
  );
}
